import dayjs from "dayjs";
import toArray from "dayjs/plugin/toArray";
import customParseFormat from "dayjs/plugin/customParseFormat";
import i18n from "@config/i18n";
import { daysEs, monthsEs } from "@utils/days";

dayjs.extend(toArray);
dayjs.extend(customParseFormat);

export const ENGLISH_DAY_TO_SPANISH_DAY = {
  Mo: "Lu",
  Tu: "Ma",
  We: "Mi",
  Th: "Ju",
  Fr: "Vi",
  Sa: "Sa",
  Su: "Do",
};

export const SHORT_WEEKDAYS_LABELS_i18n = {
  Mo: "day-list.short-names.monday",
  Tu: "day-list.short-names.tuesday",
  We: "day-list.short-names.wednesday",
  Th: "day-list.short-names.thursday",
  Fr: "day-list.short-names.friday",
  Sa: "day-list.short-names.saturday",
  Su: "day-list.short-names.sunday",
};

export const dateToWeekday = (date: string) => {
  const rawWeekday = dayjs(date).format("dd");

  if (rawWeekday in SHORT_WEEKDAYS_LABELS_i18n) {
    return i18n.t(SHORT_WEEKDAYS_LABELS_i18n[rawWeekday]);
  }

  return "-";
};

const formatDate = (date: string) => {
  const arrDate = dayjs(date).toArray();
  return new Date(arrDate[0], arrDate[1], arrDate[2], arrDate[3], arrDate[4]);
};

export const day = (date: string, format?: string) => {
  const arrayDayToDate = formatDate(date);
  const day = dayjs(arrayDayToDate).format(format || "DD.MM.YYYY");
  return day;
};

export const time = (date: string, format?: string) => {
  const arrayDayToDate = formatDate(date);
  const time = dayjs(arrayDayToDate).format(format || "HH:mm");
  return time;
};

export const DAYS_OPTIONS = () => {
  return [
    { label: i18n.t("day-list.full-names.monday"), value: "1" },
    { label: i18n.t("day-list.full-names.tuesday"), value: "2" },
    { label: i18n.t("day-list.full-names.wednesday"), value: "3" },
    { label: i18n.t("day-list.full-names.thursday"), value: "4" },
    { label: i18n.t("day-list.full-names.friday"), value: "5" },
    { label: i18n.t("day-list.full-names.saturday"), value: "6" },
    { label: i18n.t("day-list.full-names.sunday"), value: "7" },
  ];
};

export const DAYS_EN = [
  "MONDAY",
  "TUESDAY",
  "WEDNESDAY",
  "THURSDAY",
  "FRIDAY",
  "SATURDAY",
  "SUNDAY",
];

export const DAYS_ES = daysEs;

export const MONTHS_ES = monthsEs;

export const daysEnToEs = (dayEn: string) => {
  let valueEs = "";
  DAYS_EN.forEach((value: string, index: number) => {
    if (value === dayEn) valueEs = DAYS_ES[index];
  });
  return valueEs;
};

export const getSelectableDay = (dayValue: string) => {
  const isNumeric = (value: string) => /^-?\d+$/.test(value);

  if (isNumeric(dayValue)) {
    return DAYS_OPTIONS().find(value => value.value === dayValue) ?? null;
  }

  const rawDayId = dayjs(dayValue).day();
  const dayId = rawDayId === 0 ? "7" : rawDayId.toString();

  return DAYS_OPTIONS().find(value => value.value === dayId);
};

export const formatSchedule = (date: string) => {
  const dayjsDate = dayjs(date);
  const dayOfWeek = dateToWeekday(date);
  const formattedDate = dayjsDate.format("DD-MM-YYYY");
  const formattedTime = time(date);

  return {
    dayOfWeek,
    date: formattedDate,
    time: formattedTime,
    fullDateStr: `${dayOfWeek} ${formattedDate}, ${formattedTime}`,
  };
};
